import { STORAGE_KEYS } from "./storage-keys";

/**
 * Chaves do localStorage usadas no módulo de conciliação
 * Centralizadas para evitar duplicação e erros de digitação
 */
export const CONCILIATION_STORAGE_KEYS = {
  /** Tipo de NSU: "Evidence" ou "Receipt" */
  NSU_TYPE: "@verzel:nsu-type",
  /** Flag para indicar se é uma rejeição */
  REJECTED: "@verzel:rejected",
  /** ID da solicitação de e-mail */
  SOLICITATION_ID: "@email:solicitationId",
  /** ID da solicitação antiga (para comparação) */
  OLD_SOLICITATION_ID: "@email:oldSolicitationId",
  /** Token de autenticação Azure/Keycloak */
  AZURE_TOKEN: "@azure:token",
  /** Dados do usuário decodificados do token */
  AZURE_USER: "@azure:user",
  /** Módulo ativo */
  MODULE: STORAGE_KEYS.MODULE,
  /** Flag de acesso de operador */
  OPERATOR_ACCESS: "@verzel:operator-access",
  /** Menu lateral aberto ("true") ou minimizado ("false") */
  SIDEBAR: "@verzel:sidebar",
} as const;

/**
 * Tipos de NSU disponíveis
 */
export const NSU_TYPES = {
  /** NSU de evidência - Lançamento de Depósitos */
  EVIDENCE: "Evidence",
  /** NSU de comprovante - Comprovante de Depósitos */
  RECEIPT: "Receipt",
} as const;

export type NsuType = (typeof NSU_TYPES)[keyof typeof NSU_TYPES];

/**
 * Tipos de conciliação para navegação
 */
export const CONCILIATION_TYPES = {
  EVIDENCE: "evidence",
  NSU: "nsu",
} as const;

export type ConciliationType = (typeof CONCILIATION_TYPES)[keyof typeof CONCILIATION_TYPES];
